import { render, staticRenderFns } from "./MessagesFullView.vue?vue&type=template&id=6f25b08e&scoped=true&"
import script from "./MessagesFullView.vue?vue&type=script&lang=js&"
export * from "./MessagesFullView.vue?vue&type=script&lang=js&"
import style0 from "./MessagesFullView.vue?vue&type=style&index=0&id=6f25b08e&prod&scoped=true&lang=css&"
import style1 from "./MessagesFullView.vue?vue&type=style&index=1&id=6f25b08e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25b08e",
  null
  
)

export default component.exports